import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { PublicationFilterFields, type PublicationFilterFieldsValue } from "../shared/PublicationFilterFields";
import { type PublicationParams, type RegionsState } from "./useTaskCreation";

export function PublicationParamsSection(props: {
  value: PublicationParams;
  regionsState: RegionsState;
  disabled: boolean;
  onChange: <K extends keyof PublicationParams>(key: K, value: PublicationParams[K]) => void;
}) {
  const isAllRegions = props.value.regions === null;
  const primaryRegionOptions =
    props.regionsState.kind === "loaded"
      ? props.regionsState.regions.filter((row) => row.geoGroup === "primary").map((row) => row.region)
      : [];

  const filterFieldsValue: PublicationFilterFieldsValue = {
    dr: props.value.dr,
    organicKeywords: props.value.organicKeywords,
    age: props.value.age,
    uniqueSites: props.value.uniqueSites,
    includeSubdomains: props.value.includeSubdomains,
  };

  function handleFilterFieldChange(
    key: keyof PublicationFilterFieldsValue,
    value: PublicationFilterFieldsValue[keyof PublicationFilterFieldsValue],
  ) {
    switch (key) {
      case "dr":
        props.onChange("dr", value as number);
        break;
      case "organicKeywords":
        props.onChange("organicKeywords", value as number);
        break;
      case "age":
        props.onChange("age", value as number);
        break;
      case "uniqueSites":
        props.onChange("uniqueSites", value as boolean);
        break;
      case "includeSubdomains":
        props.onChange("includeSubdomains", value as boolean);
        break;
    }
  }

  return (
    <Paper variant="outlined" sx={{ p: 2, mb: 2 }}>
      <Typography variant="subtitle1" fontWeight="bold" gutterBottom>Параметры публикации</Typography>

      <Box display="flex" flexDirection="column" gap={2} maxWidth={400}>
        <FormControlLabel
          control={
            <Checkbox
              checked={isAllRegions}
              disabled={props.disabled}
              onChange={(event) => props.onChange("regions", event.target.checked ? null : [])}
            />
          }
          label="Все регионы"
        />

        {!isAllRegions && (
          <Autocomplete
            multiple
            size="small"
            options={primaryRegionOptions}
            value={props.value.regions ?? []}
            disabled={props.disabled}
            onChange={(_event, value) => props.onChange("regions", value)}
            renderInput={(parameters) => <TextField {...parameters} label="Регионы" />}
          />
        )}

        <FormControlLabel
          control={
            <Checkbox
              checked={props.value.includeSecondary}
              disabled={props.disabled || isAllRegions}
              onChange={(event) => props.onChange("includeSecondary", event.target.checked)}
            />
          }
          label="Включать secondary-регионы"
        />

        <PublicationFilterFields
          value={filterFieldsValue}
          disabled={props.disabled}
          onChange={handleFilterFieldChange}
        />
      </Box>
    </Paper>
  );
}
